// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"e6f3f198","570":"55dea9ea","581":"f0bbf569","747":"d2dadc16","926":"01340f17"}[chunkId] + ".chunk.js";
};